"use client";

import { c as _c } from "react/compiler-runtime";
import MobileWrapperDialog from "@/components/mobile-wrapper-dialog/MobileWrapperDialog";
import { useEmoji } from "@/contexts/EmojiContext";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropReaction } from "@/hooks/drops/useDropReaction";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
const WaveDropActionsAddReaction: React.FC<{
  readonly drop: ExtendedDrop;
  readonly isMobile?: boolean | undefined;
  readonly onAddReaction?: (() => void) | undefined;
}> = t0 => {
  const $ = _c(53);
  const {
    drop,
    isMobile: t1,
    onAddReaction
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const {
    react,
    canReact
  } = useDropReaction(drop, onAddReaction);
  const [showPicker, setShowPicker] = useState(false);
  const buttonRef = useRef(null);
  const pickerContainerRef = useRef(null);
  const {
    emojiMap,
    categories,
    categoryIcons
  } = useEmoji();
  let t2;
  if ($[0] !== react) {
    t2 = emoji => {
      const emojiText = `:${emoji.id ?? ""}:`;
      setShowPicker(false);
      react(emojiText);
    };
    $[0] = react;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleEmojiSelect = t2;
  let t3;
  let t4;
  if ($[2] !== showPicker) {
    t3 = () => {
      const handleClickOutside = event => {
        const target = event.target as Node;
        if (showPicker && pickerContainerRef.current && !pickerContainerRef.current.contains(target) && buttonRef.current && !buttonRef.current.contains(target)) {
          setShowPicker(false);
        }
      };
      const handleEscape = event_0 => {
        if (event_0.key === "Escape" && showPicker) {
          setShowPicker(false);
        }
      };
      if (showPicker) {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleEscape);
      };
    };
    t4 = [showPicker];
    $[2] = showPicker;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== canReact || $[6] !== showPicker) {
    t5 = () => {
      if (!canReact) {
        return;
      }
      setShowPicker(!showPicker);
    };
    $[5] = canReact;
    $[6] = showPicker;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const onReact = t5;
  const t6 = `tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${canReact ? "active:tw-bg-iron-800" : "tw-cursor-default tw-opacity-50"} tw-transition-colors tw-duration-200`;
  const t7 = !canReact;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="tw-size-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" fill="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><g transform="scale(0.024)"><path d="M958 104h-62V43q0-17-12-29T855 2h-87q-17 0-29 12t-12 29v61h-62q-17 0-29 12t-12 29v4q-81-34-169-34-116 0-217 59-97 57-154 154-58 100-58 216.5T84 761q57 98 154 155 101 58 217.5 58T672 916q97-57 154-155 59-100 59-216 0-88-34-168h4q17 0 29-12t12-29v-62h62q17 0 29-12t12-29v-88q0-17-12-29t-29-12zM644 348q29 0 49.5 20.5t20.5 49-20.5 49T644 487t-49.5-20.5-20.5-49 20.5-49T644 348zm-377 0q29 0 49.5 20.5t20.5 49-20.5 49T267 487t-49.5-20.5-20.5-49 20.5-49T267 348zm473 255q-10 70-50.5 126.5t-102 88.5-132 32-132-32-102-88.5T171 603q-2-16 8.5-27.5T206 564h499q16 0 26.5 11.5T740 603zm218-370H855v103h-87V233H665v-88h103V43h87v102h103v88z" /></g></svg>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = drop.context_profile_context?.reaction ? "Update Reaction" : "Add Reaction";
  let t10;
  if ($[9] !== t9) {
    t10 = <span className="tw-text-base tw-font-semibold tw-text-iron-300">{t9}</span>;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== onReact || $[12] !== t10 || $[13] !== t6 || $[14] !== t7) {
    t11 = <button className={t6} onClick={onReact} disabled={t7}>{t8}{t10}</button>;
    $[11] = onReact;
    $[12] = t10;
    $[13] = t6;
    $[14] = t7;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const mobileContent = t11;
  const t12 = `picker-button tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-[#FFCC22] ${canReact ? "tw-cursor-pointer" : "tw-cursor-default tw-opacity-50"}`;
  const t13 = !canReact;
  let t14;
  if ($[16] !== canReact || $[17] !== drop.id) {
    t14 = canReact ? {
      "data-tooltip-id": `add-reaction-${drop.id}`
    } : {};
    $[16] = canReact;
    $[17] = drop.id;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = `tw-size-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out ${!canReact && "tw-opacity-50"}`;
  let t16;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <g transform="scale(0.024)"><path d="M958 104h-62V43q0-17-12-29T855 2h-87q-17 0-29 12t-12 29v61h-62q-17 0-29 12t-12 29v4q-81-34-169-34-116 0-217 59-97 57-154 154-58 100-58 216.5T84 761q57 98 154 155 101 58 217.5 58T672 916q97-57 154-155 59-100 59-216 0-88-34-168h4q17 0 29-12t12-29v-62h62q17 0 29-12t12-29v-88q0-17-12-29t-29-12zM644 348q29 0 49.5 20.5t20.5 49-20.5 49T644 487t-49.5-20.5-20.5-49 20.5-49T644 348zm-377 0q29 0 49.5 20.5t20.5 49-20.5 49T267 487t-49.5-20.5-20.5-49 20.5-49T267 348zm473 255q-10 70-50.5 126.5t-102 88.5-132 32-132-32-102-88.5T171 603q-2-16 8.5-27.5T206 564h499q16 0 26.5 11.5T740 603zm218-370H855v103h-87V233H665v-88h103V43h87v102h103v88z" /></g>;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t15) {
    t17 = <svg className={t15} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">{t16}</svg>;
    $[20] = t15;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== onReact || $[23] !== t12 || $[24] !== t13 || $[25] !== t14 || $[26] !== t17) {
    t18 = <button ref={buttonRef} className={t12} onClick={onReact} disabled={t13} aria-label="Add reaction to drop" {...t14}>{t17}</button>;
    $[22] = onReact;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t17;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] !== canReact || $[29] !== drop.context_profile_context?.reaction || $[30] !== drop.id) {
    t19 = canReact && <Tooltip id={`add-reaction-${drop.id}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">{drop.context_profile_context?.reaction ? "Update Reaction" : "Add Reaction"}</span></Tooltip>;
    $[28] = canReact;
    $[29] = drop.context_profile_context?.reaction;
    $[30] = drop.id;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t18 || $[33] !== t19) {
    t20 = <>{t18}{t19}</>;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  const desktopContent = t20;
  const t21 = isMobile ? mobileContent : desktopContent;
  let t22;
  if ($[35] !== categories || $[36] !== categoryIcons || $[37] !== emojiMap || $[38] !== handleEmojiSelect || $[39] !== isMobile || $[40] !== showPicker) {
    t22 = !isMobile && showPicker && createPortal(<div className="tw-fixed tw-inset-0 tw-z-1000 tw-flex tw-items-center tw-justify-center tw-bg-black/50"><div ref={pickerContainerRef} className="tw-rounded-lg tw-bg-iron-800 tw-p-px tw-shadow-lg"><Picker theme="dark" data={data} onEmojiSelect={handleEmojiSelect} custom={emojiMap} categories={categories} categoryIcons={categoryIcons} /></div></div>, document.body);
    $[35] = categories;
    $[36] = categoryIcons;
    $[37] = emojiMap;
    $[38] = handleEmojiSelect;
    $[39] = isMobile;
    $[40] = showPicker;
    $[41] = t22;
  } else {
    t22 = $[41];
  }
  let t23;
  if ($[42] !== categories || $[43] !== categoryIcons || $[44] !== emojiMap || $[45] !== handleEmojiSelect || $[46] !== isMobile || $[47] !== showPicker) {
    t23 = isMobile && <MobileWrapperDialog isOpen={showPicker} onClose={() => setShowPicker(false)}><div className="tw-flex tw-size-full tw-items-center tw-justify-center"><Picker theme="dark" data={data} onEmojiSelect={handleEmojiSelect} custom={emojiMap} categories={categories} categoryIcons={categoryIcons} /></div></MobileWrapperDialog>;
    $[42] = categories;
    $[43] = categoryIcons;
    $[44] = emojiMap;
    $[45] = handleEmojiSelect;
    $[46] = isMobile;
    $[47] = showPicker;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t21 || $[50] !== t22 || $[51] !== t23) {
    t24 = <>{t21}{t22}{t23}</>;
    $[49] = t21;
    $[50] = t22;
    $[51] = t23;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  return t24;
};
export default WaveDropActionsAddReaction;